import { AdministratorDto } from '@/src/models/AdministratorDto';
import EntryParticipantsDto from '@/src/models/EntryParticipantDto';
import { Media } from '@/src/models/MeidaDto';

export const EntryType = {
  DAILY: 'DAILY',
  NORMAL: 'NORMAL',
  FIRST_SERVED: 'FIRST_SERVED',
  FREE: 'FREE',
} as const;

export default class EntryDto {
  type: keyof typeof EntryType;
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  startedAt: string;
  endedAt: string;
  firstServeCount: number | null;
  entryCredit: number;
  isExposed: boolean;
  priorityDisplayYn: boolean;
  sponsorDescription: string;
  sponsorLink: string;
  bottomButtonDisplayYn: boolean;
  bottomButtonName: string;
  bottomButtonLink: string;
  title: string;
  subTitle: string;
  contents: string;
  sponsorImage: Media;
  thumbnailImage: Media;
  administrator: AdministratorDto;
  // 안내사항
  entryInfos: { id?: number; contents: string }[];
  // 유의사항
  entryCautions: { id?: number; contents: string }[];
  //참여자수
  participantsCnt: number;
  //참여응모 크레딧
  participantsCredit: number;
  entryParticipants?: EntryParticipantsDto;
  // 종료 상태
  terminateStatus: any;
  firstServedRemainCnt: number;
}
